import { useMainStore } from "../../pinia/main";
import { useRoute, useRouter } from "vue-router";
import { onMounted, getCurrentInstance, reactive, ref } from "vue";
import { ElMessage } from "element-plus";
export default {
  name: "driveragreement",
  setup() {
    const router = useRouter();
    const route = useRoute();
    const mainStore = useMainStore();
    const internal = getCurrentInstance();
    const globalProperties = internal?.appContext.config.globalProperties;
    const data = reactive({
      contractInfo: {},
      isSeal: false
    });
    const customerSign = ref(null);
    onMounted(() => {
      forwarderAgreementContractCreate();
    });

    //托运人运输合同生成-1.0.8
    const forwarderAgreementContractCreate = async () => {
      var contractInfo = await globalProperties.$api.forwarderContractCreate();
      data.contractInfo = contractInfo;
    };

    //托运人运输合同签署-1.0.8
    const forwarderAgreementContractSign = async () => {
      await globalProperties.$api.forwarderContractSign();
      router.back(-1);
      ElMessage({
        type: "success",
        message: `提交成功,如需查看前往"个人中心"→"我的合同"`
      });
    };
    const sign = () => {
      ElMessage.success("您已盖章");
      data.isSeal = true;
    };
    return {
      mainStore,
      data,
      customerSign,
      forwarderAgreementContractSign,
      sign
    };
  }
};